import superTitle from '../components/components-items/super-title.vue';



// 为组件添加 install 方法，用于按需引入
superTitle.install = function (Vue) {
    Vue.component(superTitle.name, superTitle)
}




export default superTitle